var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from "react";
import { Button, Card, Checkbox, FormControl, FormLabel, Input, Option, Select, Stack, Switch, Textarea, Tooltip, Typography, } from "@mui/joy";
import { useNavigate, useParams } from "react-router-dom";
import { useFlows } from "../../data/hooks/useFlows"; // Hook to get Agents (Flows)
import { useContactGroups } from "../../data/hooks/useContactGroups"; // Hook to get Contact Groups
import { HangfireCronBuilder } from "../../components/ui/HangfireCronBuilder";
import NotificationSnackbars from "../../components/ui/NotificationSnackbars";
import { useSmsCampaigns } from "../../data/hooks/useSmsCampaigns ";
import { useWebsite } from "../../data/hooks/useWebsite";
import { DOWORK_WIDGET_TESTING, DOWORK_POPUP_OPENED } from "../../constants";
import ChatIcon from "@mui/icons-material/Chat";
import { useSearchParams } from "react-router-dom";
/** Example AI message generator stub */
var generateAiMessage = function () {
    return "Hello {Name}, just a friendly reminder from us!";
};
var AddEditCampaign = function () {
    // Retrieve optional campaign ID from URL params to determine if we're in edit mode
    var campaignId = useParams().campaignId;
    var navigate = useNavigate();
    // Whether we are editing an existing campaign or creating a new one
    var isEditMode = Boolean(campaignId);
    // --------------------------------------------------
    // Hooks to load Agents & Contact Groups from backend
    // --------------------------------------------------
    var _a = useFlows(), getFlows = _a.getFlows, flows = _a.flows; // Agents
    var _b = useContactGroups(), getAllContactGroups = _b.getAllContactGroups, contactGroups = _b.contactGroups;
    var _c = useSmsCampaigns(), createCampaign = _c.createCampaign, updateCampaign = _c.updateCampaign, getCampaignById = _c.getCampaignById;
    var _d = useSearchParams(), searchParams = _d[0], setSearchParams = _d[1];
    // --------------------------------------------------
    // State variables (UI)
    // --------------------------------------------------
    var _e = useState(""), campaignName = _e[0], setCampaignName = _e[1];
    var _f = useState(""), selectedAgent = _f[0], setSelectedAgent = _f[1]; // Will store flowId (agent ID)
    var _g = useState(), selectedContactGroup = _g[0], setSelectedContactGroup = _g[1];
    var _h = useState(""), firstMessageTemplate = _h[0], setFirstMessageTemplate = _h[1];
    var _j = useState(""), scheduledAt = _j[0], setScheduledAt = _j[1];
    var _k = useState(""), previewMessage = _k[0], setPreviewMessage = _k[1];
    var _l = useState(false), isRecurring = _l[0], setIsRecurring = _l[1];
    var _m = useState("30 17 * * *"), recurrenceFrequency = _m[0], setRecurrenceFrequency = _m[1];
    var _o = useState(false), rerunOnlyNewContacts = _o[0], setRerunOnlyNewContacts = _o[1];
    // Follow-ups
    var _p = useState([]), followUps = _p[0], setFollowUps = _p[1];
    // Testing modal
    var _q = useWebsite(), widgetScript = _q.widgetScript, getWidgetScript = _q.getWidgetScript;
    var setScript = useCallback(function () {
        // Inject script if it's the right path and script is loaded
        if (location.pathname.includes("/sms-campaign") && widgetScript) {
            var script = document.createElement("script");
            script.id = "dowork-script";
            script.type = "text/javascript";
            script.async = true;
            script.innerHTML = widgetScript
                .replace('<script type="text/javascript">', "")
                .replace("</script>", "");
            document.body.appendChild(script);
        }
    }, [widgetScript]);
    var onTest = useCallback(function () {
        sessionStorage.setItem(DOWORK_POPUP_OPENED, "true");
        sessionStorage.setItem(DOWORK_WIDGET_TESTING, "true");
        setScript();
    }, [setScript]);
    var _r = useState(null), errorMessage = _r[0], setErrorMessage = _r[1];
    var _s = useState(null), successMessage = _s[0], setSuccessMessage = _s[1];
    // --------------------------------------------------
    // Effects
    // --------------------------------------------------
    useEffect(function () {
        buildMessagePreview();
    }, [firstMessageTemplate]);
    useEffect(function () {
        // Cleanup function to remove the script when the component unmounts
        return function () {
            var widgetScript = document.getElementById("chat-widget-js");
            var script = document.getElementById("dowork-script");
            var websiteScript = document.getElementById("ask-website");
            localStorage.removeItem("DOWORK_SESSION_ID");
            if (widgetScript) {
                widgetScript.remove();
            }
            if (websiteScript) {
                document.body.removeChild(websiteScript);
            }
            if (script) {
                document.body.removeChild(script);
            }
        };
    }, [location.pathname, searchParams]);
    useEffect(function () {
        // Fetch real flows (agents) & contact groups on mount
        getFlows();
        getAllContactGroups();
        getWidgetScript();
        // If in Edit mode, fetch the existing campaign data
        var fetchCampaign = function (id) { return __awaiter(void 0, void 0, void 0, function () {
            var existing, dt, localISO, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getCampaignById(parseInt(id))];
                    case 1:
                        existing = _a.sent();
                        if (existing) {
                            setCampaignName(existing.campaignName || "");
                            setSelectedAgent(existing.conversationFlowId || "");
                            setSearchParams(__assign(__assign({}, Object.fromEntries(searchParams)), { flowId: existing.conversationFlowId }));
                            setSelectedContactGroup(existing.contactGroupId);
                            console.log(existing.contactGroupId);
                            setFirstMessageTemplate(existing.firstMessageTemplate || "");
                            if (existing.scheduledAt) {
                                dt = new Date(existing.scheduledAt);
                                localISO = new Date(dt.getTime() - dt.getTimezoneOffset() * 60000)
                                    .toISOString()
                                    .slice(0, 16);
                                setScheduledAt(localISO);
                            }
                            setIsRecurring(Boolean(existing.isRecurring));
                            if (existing.recurrenceFrequency) {
                                setRecurrenceFrequency(existing.recurrenceFrequency);
                            }
                            setRerunOnlyNewContacts(Boolean(existing.rerunOnlyNewContacts));
                            if (existing.followUps && existing.followUps.length > 0) {
                                // map them to local state shape, give them unique IDs for UI
                                setFollowUps(existing.followUps.map(function (fu, idx) { return ({
                                    id: fu.id,
                                    delayMinutes: fu.delayMinutes,
                                    useAiForMessage: fu.useAiForMessage,
                                    message: fu.message,
                                }); }));
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        setErrorMessage("Failed to load campaign data.");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (isEditMode && campaignId) {
            fetchCampaign(campaignId);
        }
    }, [campaignId, isEditMode]);
    // --------------------------------------------------
    // Helper: Build message preview
    // --------------------------------------------------
    var buildMessagePreview = function () {
        var preview = firstMessageTemplate;
        // Replace built-in placeholders.
        // For example, if the template uses {Name} or {first_name}:
        preview = preview.replace(/{Name}/gi, "John");
        // Find the selected contact group from the available groups.
        var selectedGroup = contactGroups.find(function (group) { return group.id === selectedContactGroup; });
        // If a group is selected and it has custom field definitions...
        if (selectedGroup && selectedGroup.customFieldDefinitions) {
            // For each custom field defined (e.g. key: "ServiceProvider", label: "Service Provider")
            Object.entries(selectedGroup.customFieldDefinitions).forEach(function (_a) {
                var fieldKey = _a[0], fieldLabel = _a[1];
                // Replace placeholder with a sample value. In this case, we'll use "Sample {Label}"
                preview = preview.replace(new RegExp("{".concat(fieldKey, "}"), "gi"), "'".concat(fieldLabel || fieldKey, "'"));
            });
        }
        setPreviewMessage(preview);
        return preview;
    };
    // --------------------------------------------------
    // Handle Save Campaign (Create or Update)
    // --------------------------------------------------
    var handleSaveCampaign = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, id, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!campaignName ||
                        !selectedAgent ||
                        !selectedContactGroup ||
                        !firstMessageTemplate) {
                        setErrorMessage("Please fill in all required fields.");
                        return [2 /*return*/];
                    }
                    payload = {
                        id: isEditMode && campaignId ? parseInt(campaignId) : undefined,
                        campaignName: campaignName,
                        conversationFlowId: selectedAgent,
                        contactGroupId: selectedContactGroup,
                        firstMessageTemplate: firstMessageTemplate,
                        scheduledAt: scheduledAt
                            ? new Date(scheduledAt).toISOString()
                            : undefined,
                        isRecurring: isRecurring,
                        recurrenceFrequency: isRecurring ? recurrenceFrequency : undefined,
                        rerunOnlyNewContacts: rerunOnlyNewContacts,
                        followUps: followUps.map(function (fu) { return ({
                            id: fu.id,
                            delayMinutes: fu.delayMinutes,
                            useAiForMessage: fu.useAiForMessage,
                            message: fu.message,
                        }); }),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!isEditMode) return [3 /*break*/, 3];
                    // Update existing campaign
                    return [4 /*yield*/, updateCampaign(parseInt(campaignId), payload)];
                case 2:
                    // Update existing campaign
                    _a.sent();
                    setSuccessMessage("Campaign updated successfully!");
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createCampaign(payload)];
                case 4:
                    id = _a.sent();
                    // If just created, navigate to the new capaign's edit page
                    navigate("/sms-campaign/edit/".concat(id));
                    setSuccessMessage("Campaign created successfully!");
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    setErrorMessage("Failed to save campaign.");
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    // --------------------------------------------------
    // Follow-Up Logic
    // --------------------------------------------------
    var addFollowUp = function () {
        setFollowUps(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
            {
                id: 0,
                delayMinutes: 60,
                useAiForMessage: false,
                message: "",
            },
        ], false); });
    };
    var removeFollowUp = function (id) {
        setFollowUps(function (prev) { return prev.filter(function (fu) { return fu.id !== id; }); });
    };
    var toggleAiForFollowUp = function (id, checked) {
        setFollowUps(function (prev) {
            return prev.map(function (fu) {
                if (fu.id === id) {
                    return __assign(__assign({}, fu), { useAiForMessage: checked, message: checked ? generateAiMessage() : "" });
                }
                return fu;
            });
        });
    };
    var updateFollowUp = function (id, field, value) {
        setFollowUps(function (prev) {
            return prev.map(function (fu) {
                var _a;
                return (fu.id === id ? __assign(__assign({}, fu), (_a = {}, _a[field] = value, _a)) : fu);
            });
        });
    };
    var handleAgentSelection = function (_, newVal) {
        setSelectedAgent(newVal);
        setSearchParams(__assign(__assign({}, Object.fromEntries(searchParams)), { flowId: newVal }));
    };
    return (_jsxs(Stack, __assign({ direction: "column", spacing: 2, sx: {
            width: "100%",
            height: "100%",
            overflowY: "auto",
            mx: "auto",
            p: 4,
            pt: 2,
        } }, { children: [_jsx(Typography, __assign({ level: "h2", component: "h1" }, { children: isEditMode ? "Edit Campaign" : "Create Campaign" })), _jsx(NotificationSnackbars, { errorMessage: errorMessage, successMessage: successMessage, setErrorMessage: setErrorMessage, setSuccessMessage: setSuccessMessage }), _jsxs(FormControl, __assign({ required: true, sx: { mt: 1, mb: 1 } }, { children: [_jsx(FormLabel, { children: "Campaign Name" }), _jsx(Input, { size: "sm", placeholder: "Enter campaign name", value: campaignName, onChange: function (e) { return setCampaignName(e.target.value); } })] })), _jsxs(FormControl, __assign({ required: true, sx: { mt: 1, mb: 1 } }, { children: [_jsx(FormLabel, { children: "Agent" }), _jsx(Select, __assign({ size: "sm", placeholder: "Select an agent", value: selectedAgent, onChange: handleAgentSelection }, { children: flows.map(function (flow) { return (_jsx(Option, __assign({ value: flow.id }, { children: flow.name }), flow.id)); }) }))] })), _jsxs(FormControl, __assign({ required: true, sx: { mt: 1, mb: 1 } }, { children: [_jsx(FormLabel, { children: "Select Contact Group" }), _jsx(Select, __assign({ size: "sm", placeholder: "Select a contact group", value: selectedContactGroup, onChange: function (_, newVal) { return setSelectedContactGroup(newVal); } }, { children: contactGroups.map(function (group) { return (_jsx(Option, __assign({ value: Number(group.id) }, { children: group.name }), group.id)); }) }))] })), _jsxs(FormControl, __assign({ sx: { mt: 1, mb: 1 }, required: true }, { children: [_jsx(FormLabel, { children: "First Message Template" }), _jsx(Textarea, { size: "sm", placeholder: "Hi {Name}, thanks for joining us!", value: firstMessageTemplate, onChange: function (e) { return setFirstMessageTemplate(e.target.value); }, minRows: 3 })] })), _jsxs(FormControl, __assign({ sx: { mt: 1, mb: 1 } }, { children: [_jsx(FormLabel, { children: "Message Preview" }), _jsx(Textarea, { size: "sm", readOnly: true, value: previewMessage, placeholder: "Hi {Name}, thanks for joining us!", minRows: 3 })] })), _jsxs(FormControl, __assign({ sx: { mt: 1, mb: 1 } }, { children: [_jsx(FormLabel, { children: "Scheduled Time" }), _jsx(Input, { size: "sm", type: "datetime-local", value: scheduledAt, onChange: function (e) { return setScheduledAt(e.target.value); } })] })), _jsxs(Stack, __assign({ direction: "row", alignItems: "center", sx: { mt: 1, mb: 1, }, spacing: 2 }, { children: [_jsx(FormLabel, { children: "Enable Recurring?" }), _jsx(Switch, { size: "sm", checked: isRecurring, onChange: function (e) { return setIsRecurring(e.target.checked); } })] })), isRecurring && (_jsxs(Card, __assign({ variant: "outlined", sx: { mt: 1, mb: 1, p: 2 } }, { children: [_jsx(FormControl, { children: _jsx(HangfireCronBuilder, { value: recurrenceFrequency, onChange: function (cron) { return setRecurrenceFrequency(cron); } }) }), _jsx(FormControl, __assign({ orientation: "horizontal", sx: { gap: 1 } }, { children: _jsx(Checkbox, { size: "sm", label: "Rerun only for new contacts", checked: rerunOnlyNewContacts, onChange: function (e) { return setRerunOnlyNewContacts(e.target.checked); } }) }))] }))), _jsx(Card, __assign({ variant: "outlined", sx: { mt: 1, mb: 1, p: 2 } }, { children: _jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsx(Typography, __assign({ level: "title-sm" }, { children: "Follow-Up Messages" })), _jsx(Button, __assign({ variant: "outlined", onClick: addFollowUp, sx: { alignSelf: "start" } }, { children: "Add Follow-Up" })), followUps.map(function (fu) { return (_jsx(Card, __assign({ variant: "outlined", sx: { p: 2 } }, { children: _jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsxs(FormControl, { children: [_jsx(FormLabel, { children: "Delay (Minutes)" }), _jsx(Input, { size: "sm", type: "number", value: fu.delayMinutes, onChange: function (e) {
                                                    return updateFollowUp(fu.id, "delayMinutes", Number(e.target.value));
                                                } })] }), _jsxs(Stack, __assign({ sx: { mt: 1, mb: 1 }, direction: "row", alignItems: "center", spacing: 2 }, { children: [_jsx(FormLabel, __assign({ sx: { whiteSpace: "nowrap" } }, { children: "Use AI for this message?" })), _jsx(Switch, { size: "sm", checked: fu.useAiForMessage, onChange: function (e) {
                                                    return toggleAiForFollowUp(fu.id, e.target.checked);
                                                } })] })), _jsxs(FormControl, __assign({ sx: { mt: 1, mb: 1 } }, { children: [_jsx(FormLabel, { children: "Message" }), _jsx(Textarea, { size: "sm", placeholder: "Enter follow-up message", value: fu.message, onChange: function (e) {
                                                    return updateFollowUp(fu.id, "message", e.target.value);
                                                }, minRows: 2, disabled: fu.useAiForMessage, sx: {
                                                    cursor: fu.useAiForMessage ? "not-allowed" : "text",
                                                } })] })), _jsx(Stack, __assign({ direction: "row", justifyContent: "flex-end" }, { children: _jsx(Button, __assign({ variant: "soft", color: "danger", onClick: function () { return removeFollowUp(fu.id); } }, { children: "Remove" })) }))] })) }), fu.id)); })] })) })), _jsxs(Stack, __assign({ direction: "row", justifyContent: "flex-end", spacing: 2, sx: { mb: 2, mt: 2 } }, { children: [_jsx(Tooltip, __assign({ title: !isEditMode
                            ? "Test campaign is available only after saving (edit mode)"
                            : "" }, { children: _jsx("span", __assign({ style: { display: "inline-block" } }, { children: _jsx(Button, __assign({ color: "primary", variant: "soft", disabled: !widgetScript || !isEditMode, onClick: onTest, startDecorator: _jsx(ChatIcon, {}) }, { children: "Test Campaign" })) })) })), _jsx(Button, __assign({ variant: "outlined", size: "sm", onClick: function () { return navigate("/campaigns"); } }, { children: "Cancel" })), _jsx(Button, __assign({ variant: "solid", color: "primary", onClick: handleSaveCampaign }, { children: isEditMode ? "Update Campaign" : "Save Campaign" }))] }))] })));
};
export default AddEditCampaign;
